import {
  PlayCircleOutline as PlayArrowIcon,
  SaveAltOutlined as ExportIcon,
} from '@mui/icons-material';
import { Stack } from '@mui/material';
import { lang } from 'src/utils';

import {
  StyledExportButton,
  StyledPreviewButton,
  TitleText,
} from './ReviewPageContent.styles';

interface ReviewPageContentHeaderProps {
  onExportClick: () => void;
  hasData: boolean;
  onPreviewClick: () => void;
  isPreviewEnabled?: boolean;
  isSingleLocationGroup?: boolean;
}

export const ReviewPageContentHeader = ({
  onExportClick,
  hasData,
  onPreviewClick,
  isPreviewEnabled,
  isSingleLocationGroup,
}: ReviewPageContentHeaderProps) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between">
      <TitleText variant="h3">{lang.reviewChanges}</TitleText>

      <Stack direction="row" spacing={1}>
        {isSingleLocationGroup && (
          <StyledPreviewButton
            variant="outlined"
            startIcon={<PlayArrowIcon />}
            onClick={onPreviewClick}
            disabled={!isPreviewEnabled}
            size="small">
            {lang.preview}
          </StyledPreviewButton>
        )}

        <StyledExportButton
          variant="outlined"
          startIcon={<ExportIcon />}
          onClick={onExportClick}
          disabled={!hasData}
          size="small">
          {lang.exportToCsv}
        </StyledExportButton>
      </Stack>
    </Stack>
  );
};
